<template>
  <b-dropdown
    v-if="selectedFiles.length > 0 && this.$can('update', 'object')"
    id="dropdown-1"
    class="m-md-2"
    variant="primary"
  >

    <template #button-content>
      <font-awesome-icon
        icon="check-double"
        class="mr-1"
        size="lg"
      />
      {{ selectedFiles.length }} selezionati
    </template>
    <b-dropdown-item
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      @click="download"
    >
      Download
    </b-dropdown-item>
    <b-dropdown-item
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      @click="move"
    >
      Sposta
    </b-dropdown-item>
    <b-dropdown-item
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      @click="_delete"
    >
      Elimina
    </b-dropdown-item>
    <b-dropdown-item
      v-if="!allSelected"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      @click="selectAll"
    >
      Seleziona tutti
    </b-dropdown-item>
    <b-dropdown-item
      v-if="allSelected"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      @click="selectNone"
    >
      Deseleziona tutti
    </b-dropdown-item>
    <!-- <b-dropdown-item>Second Action</b-dropdown-item>
    <b-dropdown-item>Third Action</b-dropdown-item>
    <b-dropdown-divider />
    <b-dropdown-item active> Active action </b-dropdown-item>
    <b-dropdown-item disabled> Disabled action </b-dropdown-item> -->
  </b-dropdown>

</template>
<script>
import { BDropdown, BDropdownItem } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import bulkDownloadRequest from '@/mixins/bulkDownloadRequest'
import useMyStore from '@/services/useMyStore'

export default {
  name: 'MultipleFileContextMenu',
  directives: { Ripple },
  components: {
    BDropdown,
    BDropdownItem,
  },
  mixins: [bulkDownloadRequest],
  props: {
    selectedFiles: {
      type: Array,
      default: () => [],
    },
    filesNumber: {
      type: Number,
      default: 0,
    },
  },
  setup() {
    const { currentFolder, currentObject, uploadMethod } = useMyStore()

    return {
      currentFolder, currentObject, uploadMethod,
    }
  },
  data() {
    return {}
  },
  computed: {
    allSelected() {
      return this.filesNumber === this.selectedFiles.length
    },
  },
  methods: {
    move() {
      this.$bvModal.show('multimove-modal')
    },
    _delete() {
      this.$bvModal.show('multidelete-modal')
    },
    selectAll() {
      this.$emit('select-all', true)
    },
    selectNone() {
      this.$emit('select-all', false)
    },
    download() {
      this.requestBulkDownload(this.selectedFiles.map(a => a.id), this.currentFolder)
    },
  },
}
</script>
